module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/hero-a-9400c362a4ed9aa9c4f0d063e88665f5.png";